module.exports = __webpack_public_path__ + "img/cattunnel31.56ac8120.jpg";